import type { FaireProductEntity } from "../../entity_types/product";

export const p_33dpzwm6uf: FaireProductEntity = {
  token: "p_33dpzwm6uf",
  type: "product",
  name: "Summer Day Hammock Chair *",
  brandToken: "b_42bfa9c9",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/9641b0c055754379b2b47ffd068f4f5365a1cac530daabe5daebf0e27e8a4cbd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a0e512eb2f42a766b9e779a5d09f29a5531f3bb0466f28ed038fc1981bd1aa6.jpeg",
    "https://cdn.faire.com/fastly/51afb7a65f1eb4268ca40a119ef7a5d1c1be36b30f13d6cf35c7cdbb3fac14ec.jpeg",
    "https://cdn.faire.com/fastly/222b07d2df36b902e8ed0d3b2bce1f8556e7e54a58af2c61ddb4c1e0f7dffdd8.jpeg",
    "https://cdn.faire.com/fastly/39c98f9dac3f89c77c9d70ab376ef015a6ad3bc83b79f1109d9e80c3a321538f.jpeg",
  ],
  priceDollars: 62.5,
  description:
    "It’s the best of both worlds! The Summer Day Hammock chair is the perfect mix of hammock and chair. Snuggle up with a good book in this summer’s most comfortable spot. The decorative edge adds some bohemian flare to the natural colored cotton, woven on a simple loom and tied by hand. A reinforced hanging loop means there are many days of cozy reading ahead. Oyanca Artesania helps artisans reach into the past to find a better future by helping them find markets for their traditional craft skills.\n\n* Available only in the US - Natural cotton hammock chair with Bohemian fringes and wooden cross bar - Reinforced hanging loop - 60Lx39W inches - Can hold up to 250lbs - Handmade in Nicaragua",
  tags: [],
  msrpDollars: 125,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.068Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
